import { Component, Input } from '@angular/core';
import { MatTableDataSource } from '@angular/material';

@Component({
  selector: 'app-mapa-cita-alarmas-table',
  templateUrl: './mapa-cita-alarmas-table.component.html',
  styleUrls: ['../mapa-cita.component.scss']
})
export class MapaCitaAlarmasTableComponent {

  @Input() dataSource: MatTableDataSource<any>;
  @Input() tableColumns: string[];
  @Input() resultsLength: number;
}
